import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/sync.svg';

import styles from './SyncIcon.styles';

type SyncIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'SyncIcon' });

export default function SyncIcon({ className }: SyncIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.root, className)}>
      <Icon />
    </span>
  );
}
